import Vue from 'vue'
const $ = window.$
export default Vue.directive('uniform', {
  inserted: function (el, binding, vnode) {
    $(el).uniform()
  }
})
